import { Checkbox, TableContainer } from "@material-ui/core";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as SyncSvg } from "assets/icons/Sync.svg";
import React, { memo, useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { ExpandTablePendding } from "./index";

import { useAuth0 } from "@auth0/auth0-react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Paper from "@mui/material/Paper";
import FinanceService from "Lib/API/Finance";
import { InputField, LabelField, MyCheckbox } from "components";
import AlertDialog from "components/Dialog/index";
import MyModal from "components/MyModal";
import Button from "components/button/Button";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";
import { getDateFormatForDatePicket } from "helper/dateFormat";
import moment from "moment";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import styled from "styled-components";
import { DateFormetContext } from "../../../../app/App.js";
import { CheckFloatValue } from "../../../../utils/functions";
import FinanceDrawer from "../../Drawer";

const ModalBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f3f6f9 !important;
  height: 1150px;
  width: 988px;

  > h1 {
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
  }

  :nth-child(1) > :nth-child(2) {
    background: #ffffff !important;
    display: flex;
    /* justify-content: center; */
    flex-direction: column;
    /* align-items: center; */
    border-radius: 4px;
    /* width: 841px;
    height: 366px; */
  }
`;
const TitleBox = styled.div`
  text-align: start;
  gap: 24px;
  > span {
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    color: #4f4f4f;
    > label {
      font-weight: 500;
    }
  }
`;

const TypeBox = styled.div`
  display: flex;
  justify-content: space-between;
  > :nth-child(1) {
    background-color: #e7edf9;
    width: max-content;
    border-radius: 4px;
    margin-bottom: 41px;
  }
  > :nth-child(2) {
  
  }
  > :nth-child(3) {
    width: max-content;
    margin-bottom: 35px;
    height: 48px;
    display: flex;
    background: #e7e7eb !important;
    border-radius: 5px;
    > button {
      &:disabled {
        background: #e7e7eb !important;
        border-radius: 5px !important;
        border: none;
        color: #acacac;
      }
    }
    &:disabled {
      background: #e7e7eb !important;
      border-radius: 5px !important;
      color: #acacac;
    }
  }
`;

const CreateBatch = styled.button`
  &:disabled {
    background: #e7e7eb !important;
    border-radius: 5px !important;
    cursor: not-allowed;
    border: none !important;
    color: #acacac !important;
    display: flex !important;
    justify-content: space-evenly !important;
    > i {
      color: "#acacac";
    }
  }
  color: #ffff !important;
  height: 48px !important;
  display: flex !important;
  justify-content: space-evenly !important;
  align-items: center !important;
  border-radius: 5px !important;
  min-width: 109px !important;
`;

const SelectedData = styled.div`
  display: flex;
  justify-content: space-between;
  width: 23rem;
  margin-bottom: 25px;
  > span {
    font-weight: 700;
    color: #4f4f4f;
  }
`;
const SpanHeader = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
`;
export const PeddingTable = ({
  filters,
  sortCharged,
  batch_id,
  switchType,
  type,
  setFilters,
  pendingType,
  awatingType,
  page,
  setPage,
}) => {
  const dateFormat = getDateFormatForDatePicket();

  const selectedBatch_Id = useSelector(
    (state) => state.homeReducer.selectedBatch_Id
  );

  const [openModal, setOpenModal] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [currentAccount, setCurrentAccount] = useState(null);
  const [check, setCheck] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [amount, setAmount] = useState(0);
  const [syncModal, setSyncModal] = useState(false);
  const [transactionNumber, setTransactionNumber] = useState(0);
  const [start_date, setStartDate] = useState("");
  const [enableLoading, SetEnableLoading] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);


  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {},
    validationSchema: "",
    onSubmit: async (values) => { },
  });
  
  const [newDepositData, setNewDepositData] = React.useState({
    title: "",
    batches: check,
  });
  const { getAccessTokenSilently } = useAuth0();
  const [productData, setProductData] = useState();
  const [count, setCount] = useState();
  // const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [transactionsNumber, setTransactionsNumber] = React.useState(0);

  const fetchPending = async () => {
    try {
      setIsLoading(true);
      if (filters?.filter?.date === "") {
        delete filters?.filter?.date;
      }
      if (filters?.search === "") {
        delete filters?.search;
      }

      const token = await getAccessTokenSilently();
      if (batch_id) {
        FinanceService.ViewBatchPayment(token, page + 1, 30, {
          filter: {
            batch_billing:
              selectedBatch_Id?.type === "batch"
                ? selectedBatch_Id?.data
                : batch_id,
          },
        })
          .then((res) => {
            const result = res?.payload?.data;
            setProductData(result);
            setCount(res?.payload?.pagination?.count);
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
        return;
      }

      if (pendingType === "Pending") {
        console.log(filters, "filters");
        await FinanceService.getAllBatchLists(token, page + 1, 30, filters)
          .then((res) => {
            const result = res?.payload?.data;
            setProductData(result);
            setCount(res?.payload?.pagination?.count);
            setIsLoading(false);
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
      }
      if (pendingType === "Deposited") {
        await FinanceService.getAllDepositLists(token, page + 1, 30, filters)
          .then((res) => {
            const result = res?.payload?.data;
            setProductData(result);
            setCount(res?.payload?.pagination?.count);
            setIsLoading(false);
            setSyncModal(false);
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
      }
    } catch (e) {
      setIsLoading(false);
      toastr.error("Error", e?.data?.message);
    }
  };
  const handleData = (data, name) => {
    if (name === "bank_account") {
      setNewDepositData({
        ...newDepositData,
        bank_account: { id: data?.value, title: data?.label },
      });
    } else {
      setNewDepositData({
        ...newDepositData,
        [name]: data.target.value,
      });
    }
  };

  const [pendingBatchType, setPendingBatchType] = useState("");

  const getQuickBooksURL = async (row, start_date) => {
    const token = await getAccessTokenSilently();
    setIsLoading(true);
    await FinanceService.GetDepositQuickbooks(token)
      .then((res) => {
        setIsLoading(false);
        if (res?.result?.authenticated === true) {
          createNewDeposit(row, start_date);
        } else {
          window.open(
            res?.result?.url,
            "_blank",
            "toolbar=0,location=0,menubar=0"
          );
          setHide(false);
          toastr.info("QuickBooks", "Sign in, then click Deposit again.");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toastr.error("Error", err?.data?.message);
      });
  };

  const localStorageData = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;

  const [depositID, setDepositId] = useState("");

  const extractFilenameAndId = (contentDisposition) => {
    if (!contentDisposition) return { filename: null, id: null };
  
    // Regex to extract filename
    const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    
    if (!filenameMatch || filenameMatch.length < 2) return { filename: null, id: null };
  
    const filename = filenameMatch[1]; // Extract full filename
    const idMatch = filename.match(/^(.+?)\./); // Extract ID (before .csv)
  
    const id = idMatch ? idMatch[1] : null; // Extract ID
  
    return { filename, id };
  };
  
  const downloadSageFile = (response, title) => {
    const { filename, id } = extractFilenameAndId(response?.headers["content-disposition"]);
    setDepositId(id);
    const url = window.URL.createObjectURL(new Blob([response?.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename || "Deposit.csv"}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const download = (response, title) => {
    setDepositId(response?.result?.depositId);
    const url = window.URL.createObjectURL(new Blob([response?.result?.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${title ? title + ".iif" : "Deposit.iif"}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [hide, setHide] = useState(false);

  const isProgramSage = localStorageData?.quickBooks_information?.program === "sage";
  const isProgramOnline = localStorageData?.quickBooks_information?.program === "online";
  const isProgramOffline = localStorageData?.quickBooks_information?.program === "offline";


  const createNewDeposit = async (row, start_date) => {
    try {
      setIsLoading(true);

      const body = {
        ...newDepositData,
        batches: check,
        type: pendingBatchType,
        date: moment(start_date).format("MM/DD/YYYY"),
      };
      if (newDepositData?.title.length === 0) {
        delete body.title;
      }
      const token = await getAccessTokenSilently();
      await FinanceService.createNewDeposit(body, token)
        .then((res) => {
          setIsLoading(false);
          if(filters?.search) {
            setFilters((prev) => ({
              ...prev,
              search: "",
            }));
          } else {
            fetchPending();
          }
        
          setCheck([]);
          setAmount(0);
          setNewDepositData({
            title: "",
            // bank_account: {
            //   id: "",
            //   title: "",
            // },
            batches: [],
          });

          if (isProgramOffline || isProgramSage) {
            download(res, newDepositData?.title);
          } else {
            setSyncModal(false);
          }
          setHide(false);
          toastr.success("Success", "Deposit has been synced successfully");
        })
        .catch((e) => {
          setHide(false);
          setIsLoading(false);
          if (e?.data?.reauth && e?.data?.url) {
            window.open(
              e.data.url,
              "_blank",
              "toolbar=0,location=0,menubar=0"
            );
          } else {
            setSyncModal(false);
          }
          toastr.error("Error", e?.data?.message || "Something went wrong");
          fetchPending();
        });
    } catch (e) {
      setSyncModal(false);
      setHide(false);
      setIsLoading(false);
      toastr.success("error", e?.data?.message ?? "Somthing Wrong");
    }
  };
  
  const createNewSageDeposit = async (row, start_date) => {
    try {
      setIsLoading(true);
      const body = {
        ...newDepositData,
        batches: check,
        type: pendingBatchType,
        date: moment(start_date).format("MM/DD/YYYY"),
      };
      if (newDepositData?.title.length === 0) {
        delete body.title;
      }
      const token = await getAccessTokenSilently();
      await FinanceService.createNewSageDeposit(body, token)
        .then((res) => {
          setIsLoading(false);
          if(filters?.search) {
            setFilters((prev) => ({
              ...prev,
              search: "",
            }));
          } else {
            fetchPending();
          }
        
          setCheck([]);
          setAmount(0);
          setNewDepositData({
            title: "",
            // bank_account: {
            //   id: "",
            //   title: "",
            // },
            batches: [],
          });

          if (isProgramOffline || isProgramSage) {
            downloadSageFile(res, newDepositData?.title);
          } else {
            setSyncModal(false);
          }
          setHide(false);
          toastr.success("Success", "Deposit has been synced successfully");
        })
        .catch((e) => {
          setHide(false);
          setIsLoading(false);
          setSyncModal(false);
          toastr.error("Error", e?.data?.message || "Something went wrong");
          fetchPending();
        });
    } catch (e) {
      setSyncModal(false);
      setHide(false);
      setIsLoading(false);
      toastr.success("error", e?.data?.message ?? "Somthing Wrong");
    }
  };


  useEffect(() => {
    if(Object.keys(filters || {})?.length === 0) return
    fetchPending();
  }, [filters, page, getAccessTokenSilently, pendingType, awatingType]);
  useEffect(() => {
    getPaymentMethods();
  }, []);
  const onPayNowClick = (row) => {
    document.dispatchEvent(new CustomEvent("pay-now", { detail: row }));
  };

  const onReversalClick = async (id, setReversalActionTypes) => {
    const token = await getAccessTokenSilently();

    await FinanceService.reverseCharge(id, token)
      .then(() => {
        toastr.success("Success", "Charge has been reversed");
      })
      .catch((e) => {
        toastr.error(
          "Reversal Error",
          e?.response?.data?.message ??
            e?.data?.message ??
            "An Error occured, try again later"
        );
      });
    fetchPending();
    setReversalActionTypes(false);
  };

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   * @param {string} accountId
   */

  const [prevType, setPrevType] = useState([]);

  const onCheckboxChange = (e, row, all = false) => {
    const { checked } = e.target;
    if (all === false) {
      const id = row?._id;
      if (!checked) {
        setAmount(amount - row?.amount);
        setTransactionNumber(transactionNumber - row.transactions?.length);

        setPrevType((prev) => {
          const checkClone = prev?.filter((item) => item?.id !== id);
          if (!checkClone.length) {
            setPrevType([]);
          }

          return [...checkClone];
        });

        setCheck((prev) => {
          const checkClone = prev.filter((item) => item !== id);
          if (!checkClone.length) {
            setCurrentAccount(null);
          }

          return [...checkClone];
        });
        return;
      } else {
        setTransactionNumber(transactionNumber + row.transactions?.length);

        setAmount(amount + row?.amount);

        setPrevType((prev) => [...prev, { type: row?.type, id: row?._id }]);

        setCheck((prev) => [...prev, id]);
      }
    } else {
      if (!checked) {
        setAmount(0);
        setTransactionNumber(0);
        setCheck([]);
      } else {
        let tempAmount = amount;

        row.map((ele) => {
          const id = ele?._id;
          if (!check.includes(id)) {
            tempAmount += ele?.amount;

            setCheck((prev) => [...prev, id]);
          }
        });
        setAmount(tempAmount);
      }
    }
  };
  const modifyRowData = (row, item) => {
    const modified = { ...row, charge: { ...row.charge }, ...item };
    setDrawerData(modified);
    setOpenModal(true);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 30));
    setPage(0);
  };
  const getPaymentMethods = async () => {
    const token = await getAccessTokenSilently();
    const res = await FinanceService.getPaymentMethods(token);
    if (res?.result) {
      setPaymentMethods(res?.result);
    }
  };
  useEffect(() => {
    setFilters({
      filter: {
        // charge_type: "charge",
        // syncedBatch: true,
        // method: "all",
        // paid_at: "",
      },

      status: filters.status,
    });
  }, [filters.status]);
  const getCommaSeperatedValue = (num) => {
    return (
      CheckFloatValue(num)
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0.0
    );
  };

  const Undeposit = async (id) => {
    const token = await getAccessTokenSilently();
    await FinanceService.Undeposit(id, token)
      .then((res) => {
        toastr.success("Success", "Undeposit sucsess");
        setSyncModal(false);
        fetchPending();
      })
      .catch((e) => {
        setSyncModal(false);
        fetchPending();
        toastr.error("Error", e?.data?.message ?? "Something went wrong");
      });
  };
  
  const handleDepositValue = (row) => {
    setHide(true)
    if (isProgramOnline) {
      getQuickBooksURL(row, start_date);
    } else if (isProgramSage) {
      createNewSageDeposit(row, start_date);
    } else {
      createNewDeposit(row, start_date);
    }
  };

    const handleSyncMark = async (Id) => {
      const token = await getAccessTokenSilently();
      SetEnableLoading(true);
      await FinanceService.markSynced(Id, token)
        .then((res) => {
          SetEnableLoading(false);
          if (res) {
            setSyncModal(false);
            fetchPending();
          }
        })
        .catch((e) => {
          SetEnableLoading(false);
          toastr.error("Error", e?.data?.message ?? "Something went wrong");
        });
    };
  
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setSyncModal(false)
  }

  const closeSyncModal = () => {
    setConfirmClose(true);
  }

  
  return (
    <div className="w-100">
      <div className="family-table-container p-7 pb-15 synced-batch-table">
        <div className="home-table-container mt-0 no-box-shadow">
          <TypeBox>
            <div
              className="d-flex align-items-center"
              style={{ height: "36px" }}
            >
              <button
                type="button"
                onClick={() => {
                  switchType("Pending");
                  setPage(0);
                }}
                className={
                  type === "Pending"
                    ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                    : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                }
                style={{ height: "24px" }}
              >
                Pending Batches
              </button>{" "}
              <button
                type="button"
                onClick={() => {
                  switchType("Deposited");
                  setPage(0);
                }}
                style={
                  type === "Deposited"
                    ? { color: "#FFFFFF", height: "28px" }
                    : { color: "#2555EF", height: "28px" }
                }
                className={
                  type === "Deposited"
                    ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                    : `btn  btn-clean font-weight-bold m-2 d-flex align-items-center`
                }
              >
                Deposited
              </button>{" "}
            </div>
            {pendingType === "Pending" && (
              <div>
                <Button
                  type="button"
                  variant="primary"
                  size="md"
                  onClick={() => {
                    setSyncModal(true);
                    setDepositId("");
                  }}
                  disabled={check?.length === 0 || isLoading === true}
                  style={{ minWidth: "100px" }}
                >
                  <SyncSvg /> <span>Sync</span>
                </Button>{" "}
              </div>
            )}
          </TypeBox>

            <TableContainer component={Paper} className="scroll-table">
              <>
                {check?.length > 0 && (
                  <SelectedData>
                    <span> {check?.length} batches selected</span>
                    <span>Total Amount: {getCommaSeperatedValue(amount)}</span>
                  </SelectedData>
                )}
                <Table aria-label="collapsible table"
                  className={`${isLoading === true ? "d-flex flex-column" : ""}`}
                >
                  <TableHead className="sticky-table-header">
                    <TableRow className="main-table__header">
                      {pendingType === "Pending" ? (
                        <TableCell padding="checkbox" className="main-check">
                          <MyCheckbox
                            color="primary"
                            handlechange={(e) =>
                              onCheckboxChange(e, productData, true)
                            }
                            checked={check?.length === productData?.length}
                          />
                          {/* <MyCheckbox
                            name={"visible"}
                            color="primary"
                            handlechange={(e) =>
                              onCheckboxChange(e, productData, true)
                            }
                            checked={check?.length === productData?.length}
                          /> */}
                        </TableCell>
                      ) : (
                        <TableCell />
                      )}
                      {pendingType === "Pending" && <TableCell />}
                      <TableCell
                        style={{
                          width: "100px",
                          minWidth: "100px",
                          maxWidth: "100px",
                        }}
                      >
                        {pendingType === "Pending" ? (
                          <SpanHeader>{"batch#".toUpperCase()}</SpanHeader>
                        ) : (
                          <SpanHeader>{"Deposit id".toUpperCase()}</SpanHeader>
                        )}
                      </TableCell>

                      <TableCell align="left"
                        style={{
                          minWidth: "150px",
                        }}
                      >
                        <SpanHeader>{"total amount".toUpperCase()}</SpanHeader>
                      </TableCell>

                      <TableCell align="left">
                        <SpanHeader>{"Type".toUpperCase()}</SpanHeader>
                      </TableCell>

                      {pendingType === "Pending" && (
                        <TableCell align="left"
                          style={{
                            minWidth: "150px",
                          }}
                        >
                          <SpanHeader>{"Bank account".toUpperCase()}</SpanHeader>
                        </TableCell>
                      )}
                      {pendingType === "Pending" && (
                        <TableCell align="left">
                          <SpanHeader>{"Deposit id".toUpperCase()}</SpanHeader>
                        </TableCell>
                      )}
                      <TableCell align="left"
                        style={{
                          minWidth: "150px",
                        }}
                      >
                        <SpanHeader>{"deposit Name".toUpperCase()}</SpanHeader>
                      </TableCell>
                      {/* ... */}
                      <TableCell align="left">
                        <SpanHeader>{pendingType === "Pending" ? "Batch date".toUpperCase() : "Deposit date".toUpperCase()}</SpanHeader>
                      </TableCell>
                      {pendingType === "Deposited" && (
                        <TableCell align="left">
                          <SpanHeader>{"Sync".toUpperCase()}</SpanHeader>
                        </TableCell>
                      )}
                      <TableCell className="sticky-header-column" align="left"></TableCell>
                      {/* ... */}
                    </TableRow>
                  </TableHead>
                  {isLoading && (
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center"
                      style={{ marginBottom: "11rem" }}
                    >
                      <Loader />
                    </div>
                  )}
                  {isLoading === false && (
                  <>
                  {productData?.length === 0 ? (
                    <td colSpan={12}>
                      <div className="record-text">No record found</div>
                    </td>
                  ) : (
                    productData?.map((row) => (
                      <TableBody>
                        <ExpandTablePendding
                          modifyRowData={modifyRowData}
                          key={row.name}
                          row={row}
                          depositID={depositID}
                          prevType={prevType}
                          onCheckboxChange={onCheckboxChange}
                          check={check}
                          transactionNumber={transactionNumber}
                          onPayNowClick={onPayNowClick}
                          onReversalClick={onReversalClick}
                          setDrawerData={setDrawerData}
                          setOpenModal={setOpenModal}
                          setHide={setHide}
                          hide={hide}
                          createNewDeposit={createNewDeposit}
                          getQuickBooksURL={getQuickBooksURL}
                          setPendingBatchType={setPendingBatchType}
                          syncModal={syncModal}
                          setSyncModal={setSyncModal}
                          handleData={handleData}
                          newDepositData={newDepositData}
                          isLoading={isLoading}
                          setIsLoading={setIsLoading}
                          transactionsNumber={transactionsNumber}
                          amount={amount}
                          pendingType={pendingType}
                          fetchMyAPI={fetchPending}
                          type={type}
                          filters={filters}
                          switchType={switchType}
                          setStartDate={setStartDate}
                          start_date={start_date}
                        />
                      </TableBody>
                    ))
                  )}
                  </>
                  )}
                </Table>
              </>
            </TableContainer>
            {productData?.length === 0 ? (
              ""
            ) : (
              <div className="pagination-custom mt-2">
                <Pagination
                  count={Math.ceil(count / 30)}
                  color="primary"
                  page={page + 1}
                  variant="outlined"
                  onChange={(event, value) => {
                    setPage(value - 1);
                  }}
                />
              </div>
            )}

            <MyModal
              className={" new-charge-modal"}
              open={syncModal}
              onClose={closeSyncModal}
            >
              <ModalBox className=" col-mb-12 col-xs-12 col-lg-12 col-sm-12  pl-0 pr-0">
                <h1 className="pb-5 pt-2">New Deposit</h1>
                <div className="col-mb-11 col-xs-11 col-lg-11 col-sm-11 pt-20 pb-20 pr-20 pl-15">
                  <TitleBox className="pb-13 d-flex ">
                    <span>
                      {check?.length} batches, {transactionNumber} transactions
                    </span>
                    <span>
                      {" "}
                      <label> Total Amount&nbsp;: </label>
                      &nbsp;&nbsp;{amount}
                    </span>
                  </TitleBox>
                  <div className=" col-mb-12 col-xs-12 col-lg-12 col-sm-12  pl-0 pr-0">
                    <div className=" col-mb-12 col-xs-12 col-lg-12 col-sm-12  pl-0 pr-0">
                      <InputField
                        {...{
                          formik,
                          title: "Deposit Name (optional)",
                          name: "depositName",
                          value: newDepositData?.title,
                        }}
                        style={{
                          backgroundColor: "#F3F6F9",
                          fontWeight: "500",
                          fontSize: "14px",
                          lineHeight: "150%",
                        }}
                        handleChange={(e) => handleData(e, "title")}
                      />
                    </div>
                    <div
                      className="col-mb-12 col-xs-12 col-lg-12 col-sm-12 pl-0 pr-0"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "1rem",
                      }}
                    >
                      <div className="col-mb-5 col-xs-5 col-lg-5 col-sm-5 pl-0 pr-0">
                        <InputField
                          {...{
                            formik,
                            title: "Batch ID's",
                            name: "BatchID",
                          }}
                          value={check?.join(",")}
                          disabled={true}
                          style={{ backgroundColor: "#F3F5F9" }}
                        />
                      </div>
                      <div className="col-mb-5 col-xs-5 col-lg-5 col-sm-5 pl-0 pr-0">
                        <LabelField title={"Batch Date"} />
                        <ReactDatePicker
                          placeholderText={"Select Date"}
                          dateFormat={dateFormat}
                          className="date-picker-custom new-batch-daterange"
                          selected={start_date}
                          onChange={(date) => setStartDate(date)}
                        />
                      </div>
                      {/* <div
                        className="col-mb-5 col-xs-5 col-lg-5 col-sm-5 pl-0 pr-0 bankAccount"
                        style={{ height: "100px" }}
                      >
                        <LabelField
                          className={
                            "member-info-form-lable form-group fv-plugins-icon-container m-0 p-0"
                          }
                          htmlFor={"bankAccount"}
                          title={"Bank Account"}
                        />
                        <Select
                          isClearable={true}
                          isSearchable={true}
                          name="bankAccount"
                          styles={customStyles}
                          options={bankAccountList}
                          onChange={(e) => handleData(e, "bank_account")}
                          value={newDepositData?.bank_account?.label}
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
                <div
                  className=" col-mb-6 col-xs-6 col-lg-6 col-sm-6  pl-0 pr-0 d-flex justify-content-center mt-25 mb-10 "
                  style={{ gap: 10 }}
                >
                  <Button
                    type="button"
                    variant="primary-outline"
                    size="md"
                    disabled={isLoading}
                    onClick={() => {
                      (isProgramOffline || isProgramSage) && depositID
                        ? Undeposit(depositID)
                        : closeSyncModal();
                    }}
                    style={{ minWidth: "100px" }}
                  >
                    Cancel
                  </Button>

                  {console.log(isLoading, "isLoading")}

                  <Button
                    type="button"
                    className={
                      isLoading
                        ? "disabled  font-weight-bold"
                        : "btn btn-primary font-weight-bold"
                    }
                    onClick={() => {
                      if(!start_date) return toastr.error("Error", "Please select date");
                      handleDepositValue(check);
                    }}
                    disabled={hide || !start_date}
                    style={{ minWidth: "100px" }}
                    variant="primary"
                    size="md"
                  >
                    {/* {isLoading ? <CircularProgress /> : "Deposit"} */}
                    {isLoading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <Loader />
                      </div>
                    ) : (isProgramOffline || isProgramSage) ? (
                      "Download"
                    ) : (
                      "Deposit"
                    )}
                  </Button>

                  {(isProgramOffline || isProgramSage) &&
                    depositID && (
                      <Button
                        type="button"
                        disabled={enableLoading}
                        onClick={() => {
                          handleSyncMark(depositID);
                        }}
                        style={{ minWidth: "100px" }}
                        variant="primary"
                        size="md"
                      >
                        Mark As Sync
                      </Button>
                    )}
                </div>
              </ModalBox>
            </MyModal>
            <AlertDialog
              open={confirmClose}
              onDecline={() => {
                setConfirmClose(false);
              }}
              onAccept={confirmCloseHandler}
              title={"Are you sure?"}
              description={"Do you want to discard the changes you made?"}
            />
        </div>
      </div>
    </div>
  );
};
